import { getConfig } from '../helpers';
import SPGVariables from './spg-variables';

const spgVariables = SPGVariables();
const urls = getConfig('urls');
const buildImageUrl = (urlString?: string) => {
    if (urlString && urlString.length) {
        return urlString.indexOf('http') > -1 || urlString.substr(0, 1) === '/' || urlString.substr(0, 2) === '..'
            ? urlString
            : `${spgVariables.CloudFrontURL}/${urlString}`;
    }
    return undefined;
};

export default buildImageUrl;
